import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-doctor2_record_list",
  "use": "icon-doctor2_record_list-usage",
  "viewBox": "0 0 22 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 24\" id=\"icon-doctor2_record_list\"><defs><style>#icon-doctor2_record_list .a{fill:#fff;}</style></defs><path class=\"a\" d=\"M179.528,128h-17.08A2.432,2.432,0,0,0,160,130.405v19.188A2.43,2.43,0,0,0,162.448,152h17.1A2.43,2.43,0,0,0,182,149.593V130.387A2.464,2.464,0,0,0,179.528,128Zm-15.26,3.466h13.418a1.136,1.136,0,1,1,0,2.272H164.27a1.136,1.136,0,1,1,0-2.272Zm0,7.8a1.137,1.137,0,1,1,0-2.274h5.564a1.137,1.137,0,1,1,0,2.274H164.27ZM178.576,146h-2.342v2.3a1.16,1.16,0,0,1-2.32,0V146H171.57a1.14,1.14,0,1,1,0-2.28h2.342v-2.3a1.16,1.16,0,0,1,2.32,0v2.3h2.34a1.14,1.14,0,1,1,0,2.28Z\" transform=\"translate(-160 -127.999)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/doctor2_record_list.svg
// module id = r98E
// module chunks = 10